import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { closePopover } from '../../actions/popover'
import { CX } from '../../constants'
import PopoverLayout from './popover_layout'
import Icon from '../icon'
import Text from '../text'

class StatusVisibilityDropdown extends React.PureComponent {
  handleChange = privacy => {
    this.props.onVisibility(privacy)
    this.props.onClosePopover()
  }
  render() {
    const { privacy, isXS } = this.props

    const options = [
      {
        icon: 'globe',
        value: 'public',
        title: 'Public',
        subtitle: 'Visible for anyone on or off Gab',
      },
      {
        icon: 'unlock-filled',
        value: 'unlisted',
        title: 'Unlisted',
        subtitle: 'Do not show in public timelines',
      },
      {
        icon: 'lock-filled',
        value: 'private',
        title: 'Followers-only',
        subtitle: 'Visible for your followers only',
      }
    ]

    return (
      <PopoverLayout width={300} isXS={isXS} onClose={this.onClosePopover}>
        <Text className={[_s.d, _s.px15, _s.py10, _s.bgSecondary].join(' ')}>
          Status Visibility:
        </Text>
        <div className={[_s.d].join(' ')}>
          {options.map((option, i) => {
            const isActive = option.value === privacy
            const isLast = i === options.length - 1

            const containerClasses = CX({
              d: 1,
              flexRow: 1,
              py10: 1,
              cursorPointer: 1,
              borderBottom1PX: !isLast,
              borderColorSecondary: !isLast,
              bgSubtle_onHover: !isActive,
              bgBrand: isActive
            })

            const iconClasses = CX({
              ml10: 1,
              mt2: 1,
              cPrimary: !isActive,
              cWhite: isActive
            })

            return (
              <div
                key={`status-visibility-item-${i}`}
                role="button"
                onClick={() => this.handleChange(option.value)}
                className={containerClasses}
              >
                <Icon id={option.icon} size="16px" className={iconClasses} />
                <div className={[_s.d, _s.px10, _s.pt2].join(' ')}>
                  <Text size="medium" color={isActive ? 'white' : 'primary'}>
                    {option.title}
                  </Text>
                  <Text
                    size="small"
                    weight="medium"
                    color={isActive ? 'white' : 'secondary'}
                  >
                    {option.subtitle}
                  </Text>
                </div>
              </div>
            )
          })}
        </div>
      </PopoverLayout>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  onClosePopover: () => dispatch(closePopover())
})

StatusVisibilityDropdown.propTypes = {
  isXS: PropTypes.bool,
  onVisibility: PropTypes.func.isRequired,
  onClosePopover: PropTypes.func.isRequired,
  privacy: PropTypes.string.isRequired
}

export default connect(null, mapDispatchToProps)(StatusVisibilityDropdown)